import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-events-event',
  templateUrl: './events-event.component.html',
  styleUrls: ['./events-event.component.scss']
})
export class EventsEventComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
